import React from 'react';
import { FaCalendar, FaCertificate, FaHome } from 'react-icons/fa';
import { useLoaderData } from 'react-router-dom';
import Footer from '../components/Footer';
import ProgramDetailsView from '../components/ProgramDetailsView';

const ProgramDetails = () => {
  const program = useLoaderData();
    // const handleDownload = () => {
    //     fetch('').then(res => {
    //         res.blob().then(blob => {
    //             const fileURL = window.URL.createObjectURL(blob);
    //             let alink = document.createElement('a');
    //             alink.href = fileURL;
    //             alink.download = 'sample.pdf';
    //             alink.click();
    //         })
    //     })
    // }

  return (
    <>
      <ProgramDetailsView program={program} />
      <Footer />
    </>
  );
}

export default ProgramDetails

export const programDetailsLoader = async ({ params }) => {
    //const { id } = params
    //const res = await fetch(`http://localhost:3000/undergraduatePrograms/${id}`);
    //const res = programdata;
    //if (!res.ok) {
      //  throw Error("Could not find that program");
    //}
    //return programdata;
    //res.json();
    //const { id } = params
    const res = await fetch('/programdata/db.json');

    const data = await res.json();
    const program = data.undergraduatePrograms.find(
      (item) => item.id.toString() === params.id
    );
  
    if (!program) {
      throw new Error("Program not found");
    }
    return program;
  
}
